/**
 * A container class for the configuration of a single cache pool.
 */
class HttpCachePoolConfig {
  constructor(name, config) {
    this.name = name
    this.test = config.test
    this.strategy = config.strategy
    this.timeToLive = config.timeToLive
    this.service = config.service
    this.serviceArgs = config.serviceArgs
  }
}

export default HttpCachePoolConfig
